<!-- eslint-disable -->
<template lang="pug">
    .tooltip(v-on-clickaway="close")
        .tooltip__info(@click="isTooltipDisplayed = true")
            slot
        .tooltip__body(
            :class="{'tooltip__body--block': isTooltipDisplayed}",
        )
            slot(name="popup")
</template>

<script>
    /*eslint-disable*/
    import {mixin as clickaway} from 'vue-clickaway'

    export default {
        mixins: [clickaway],
        data () {
            return {
                isTooltipDisplayed: false
            }
        },
        methods: {
            close () {
                this.isTooltipDisplayed = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tooltip {
        display: inline-flex;
        position: relative;
        &:hover {
            .tooltip__body {
                display: block;
            }
        }
    }

    .tooltip__info {
        cursor: pointer;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .tooltip__body {
        display: none;
        position: absolute;
        top: 125%;
        left: -225%;
        z-index: 9;
        background-color: white;
        border-radius: $border-radius-8;
        border: 1px solid $hsl-color-gray-92;
        width: 250px;
        padding: 12px;
    }

    .tooltip__body--block {
        display: block;
    }
</style>
